// extracted by mini-css-extract-plugin
module.exports = {"saleTime":"SaleTime_saleTime__ha5d9"};